var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormkitTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.5C4.14 15.5 1 12.36 1 8.5C1 4.64 4.14 1.5 8 1.5C11.86 1.5 15 4.64 15 8.5C15 12.36 11.86 15.5 8 15.5ZM8 2.5C4.69 2.5 2 5.19 2 8.5C2 11.81 4.69 14.5 8 14.5C11.31 14.5 14 11.81 14 8.5C14 5.19 11.31 2.5 8 2.5Z",
    fill: "#23459B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11C9.91001 11 9.82001 10.98 9.74001 10.93L7.24001 9.43C7.1663 9.38513 7.10546 9.32195 7.0634 9.24659C7.02134 9.17124 6.99951 9.08629 7.00001 9V5C7.00001 4.72 7.22001 4.5 7.50001 4.5C7.78001 4.5 8.00001 4.72 8.00001 5V8.72L10.26 10.07C10.3531 10.1271 10.425 10.2129 10.4649 10.3145C10.5049 10.4162 10.5105 10.528 10.4811 10.6332C10.4517 10.7383 10.3889 10.831 10.302 10.8972C10.2152 10.9634 10.1092 10.9995 10 11Z",
    fill: "#23459B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormkitTime);
export default __webpack_public_path__ + "static/media/formkit_time.03dc1be15d33be346ff38b0fda26520b.svg";
export { ForwardRef as ReactComponent };